// import "@hotwired/turbo-rails"
import "./controllers/admin.js"

import './common/add_jquery'
import "./admin/js/app.js";
import "./admin/js/app.init.dark.js";
import "./admin/js/sidebarmenu.js";
import './custom_bootstrap.js'
import "./common/notice/notice"
import "./common/imagecoo/imagecoo"
import "./common/picker/picker"
import "./common/picker/colorpicker"
import "./common/validation/validation"
import "./common/charts/charts"
import "./admin/js/custom.js";
import "@nathanvda/cocoon";


$(function() {
    $("form[novalidate='novalidate']").find("input,select,textarea").not("[type=submit]").jqBootstrapValidation();

    $('.row1').on('change','input[type="file"]', function(e) {
        const size = e.target.files[0].size / 1024 / 1024;
        if(size > (10 / 1.3) ){
            $(this).val("");
            $(this).after('<div class="help-block text-danger"><ul role="alert"><li>圖片 size 編修後會超過 10MB</li></ul></div>')
        }else{
            $(this).parents(".form-group").find(".help-block").remove()
        }
    })
    $('input[type="file"]').on('change', function(e) {
        const size = e.target.files[0].size / 1024 / 1024;
        const type = e.target.files[0].type;
        if(type == "image/jpeg" || type == "image/png" || type == "image/gif" || type == "image/jpg"){
            if(size > (10 / 1.3) ){
                $(this).val("");
                $(this).after('<div class="help-block text-danger"><ul role="alert"><li>圖片 size 編修後會超過 10MB</li></ul></div>')
            }else{
                $(this).parents(".form-group").find(".help-block").remove()
            }  
        }

    })
});
  
  